import { LikertScale } from './LikertScale';

interface AssessmentQuestionCardProps {
  questionText: string;
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function AssessmentQuestionCard({
  questionText,
  value,
  onChange,
  disabled,
}: AssessmentQuestionCardProps) {
  return (
    <div className="card-premium max-w-3xl mx-auto animate-fade-up">
      {/* Question text - no section/domain badge shown (to avoid bias) */}
      <h2 className="font-display text-xl md:text-2xl font-semibold text-foreground mb-8 leading-relaxed">
        {questionText}
      </h2>

      {/* Likert scale */}
      <LikertScale
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
